import '../styles/components/Footer.scss'
import { CiMail } from "react-icons/ci";
import { FaFacebookF, FaWhatsapp } from "react-icons/fa";
import { LuInstagram } from "react-icons/lu";
import wetekup from '../assets/icons/wetekup.svg'
import finisher from '../assets/contact-bottom.svg'
import finisherMobile from '../assets/contact-bottom-mobile.svg'
import { useLocation } from "react-router-dom";
import phone from '../assets/icons/phone.svg'

const Footer = () => {
    const location = useLocation()

    return (
        <footer className="footer" style={location.pathname !== "/Contact" ? { borderTop: '1px solid #D3D3D3' } : {}}>
            {location.pathname === "/Contact" && (
                <div className="footer-contact-image">
                    <img src={window.innerWidth > 768 ? finisher : finisherMobile} alt="Contact Banner" />
                </div>
            )}

            <div className='footer-main'>
                <div className='footer-description'>
                    <p> Fait main avec amour </p>
                    <p> Une marque 100% tunisienne </p>
                    <p> Cadeaux personnalisés et uniques </p>
                    <p> Une démarche responsable </p>
                </div>
                <div className='footer-contact'>
                    <h3> Contact </h3>
                    <p> <CiMail /> Michkette.tn01@gmail.com  </p>
                    <p> <img src={phone} alt='phone' /> +216 99727060  </p>
                </div>
                <div className='footer-findus'>
                    <h3> Nous trouver </h3>
                    <div className='social-icons'>
                        <a href='https://www.facebook.com/bety.for.accessory'><FaFacebookF size={24}  style={{cursor:'pointer'}} /></a>
                        <a href='https://www.instagram.com/michkette.tn/'><LuInstagram size={24} /></a>
                        <a href='https://wa.me/+21699727060'><FaWhatsapp size={24}/></a>
                    </div>
                </div>
                <div className='footer-languages'>
                    <h3> Langue </h3>
                    <select> 
                        <option> Francais </option>
                        <option> Anglais </option>
                        <option> Arabe </option>
                    </select>
                </div>
            </div>
            <hr />
            <div className='footer-copyrights'>
                <p> 
                    <img src={wetekup} alt='wetekup logo minimal' />
                    © {new Date().getFullYear()} Michkette. Tous droits réservés. Site conçu par  
                    <a href='https://www.instagram.com/we.tekup/' target='_blank'>WE TEKUP</a>
                </p>
            </div>
        </footer>
    )
}

export default Footer
